var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurityLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.207,
    height: 87.126,
    viewBox: "0 0 87.207 87.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_password",
    transform: "translate(-20.836 -21.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M157.019,143.2a1.836,1.836,0,1,0-3.257,1.7,39.909,39.909,0,0,1-63.623,46.638,1.836,1.836,0,0,0-3.134,1.3v10.555a1.836,1.836,0,1,0,3.672,0v-6.409A43.584,43.584,0,0,0,157.019,143.2Z",
    transform: "translate(-53.894 -98.552)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M36.244,36.551a39.95,39.95,0,0,1,56.432,0,1.835,1.835,0,0,0,3.134-1.3V24.7a1.836,1.836,0,0,0-3.672,0v6.409A43.584,43.584,0,0,0,25.795,84.885a1.836,1.836,0,1,0,3.257-1.7,39.744,39.744,0,0,1,7.192-46.638Z",
    transform: "translate(0)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M126.4,232.564v20.3a5.023,5.023,0,0,0,5.009,5.009h38.065a5.023,5.023,0,0,0,5.009-5.009v-20.3a5.023,5.023,0,0,0-5.009-5.009H131.41A5.024,5.024,0,0,0,126.4,232.564Zm37.4,6.228a3.923,3.923,0,1,1-3.923,3.923A3.923,3.923,0,0,1,163.8,238.792Zm-13.356,0a3.923,3.923,0,1,1-3.923,3.923,3.923,3.923,0,0,1,3.923-3.923Zm-13.356,0a3.923,3.923,0,1,1-3.923,3.923A3.923,3.923,0,0,1,137.086,238.792Z",
    transform: "translate(-85.982 -168.066)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M200.867,107.039v-6.679a16.26,16.26,0,1,0-32.52,0v6.679h3.672v-6.679a12.588,12.588,0,1,1,25.177,0v6.679Z",
    transform: "translate(-120.147 -51.222)",
    fill: "#ff3535"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityLock);
export default __webpack_public_path__ + "static/media/security-lock.ec5f805a9b32610493ec547990d7bc01.svg";
export { ForwardRef as ReactComponent };